import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import makeRequest from 'utils/makeRequest';
import { loginEventEmitter } from 'components/Login';
import PrimePaymentFlowLoader from 'components/PrimePaymentFlow';
import Cookie from 'utils/cookies';
import { getDomainOnly } from 'utils/common';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { getPrcCookieValue } from 'utils/primeUtil';
import { PRC_FOR_NEVER_REGISTER, PRC_FOR_SUBSCRIBED } from 'constants/index';
import {
  timesPrimeLearnMoreAPIURL,
  timesPrimeLearnMoreAPIURLMOBILE,
  timesPrimeSubscribeNowAPIURL,
} from './config';

class PrimePaymentFlowCaller extends React.Component {
  constructor() {
    super();
    this.subribeNowFlow = false;
    this.state = {
      showPaymentFlow: false,
      formType: '',
      iscongratsScreen: false,
      isPrimePaymentFlowLoaded: false,
    };
    this.event = null;
    this.startPrimePaymentFlow = this.startPrimePaymentFlow.bind(this);
  }

  componentDidMount() {
    window.addEventListener(
      'prime_paymentflow_start',
      this.startPrimePaymentFlowHandler,
      false,
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      'prime_paymentflow_start',
      this.startPrimePaymentFlowHandler,
    );
  }

  startPrimePaymentFlow = evt => {
    this.deleteiprCookie();

    this.event = evt;
    if (evt && evt.detail && evt.detail.formType === 'learnMoreScreen') {
      this.learnMoreHandler();
    } else if (evt && evt.detail && evt.detail.formType === 'paymentScreen') {
      const _prc = getPrcCookieValue('prc');
      if (_prc !== PRC_FOR_NEVER_REGISTER) {
        this.subscribeNow(evt);
      } else {
        this.subribeNowFlow = true;
        // let route to activation flow, which will open login and verify mobile number.
        this.startFreeTrialActivationFlow();
      }
    } else {
      this.subribeNowFlow = false;
      this.startFreeTrialActivationFlow();
    }
  };

  startFreeTrialActivationFlow = evt => {
    let formType = 'verifyMobileScreen';
    if (evt && evt.detail) {
      if (evt.detail.formType) {
        formType = evt.detail.formType;
      }
      if (typeof evt.detail.callback === 'function') {
        this.requestedCallback = evt.detail.callback;
      }
    }
    this.setState({
      showPaymentFlow: true,
      formType,
    });
  };

  startPrimePaymentFlowHandler = evt => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ isPrimePaymentFlowLoaded: true });
    this.primeEvt = evt;
    const isUserLoggedin = this.props.userData.isLoggedIn;
    if (isUserLoggedin || (evt && evt.detail.formType === 'learnMoreScreen')) {
      this.startPrimePaymentFlow(evt);
    } else {
      loginEventEmitter(this.startPrimePaymentFlow.bind(this, evt), {
        isMobileOnlyLogin: true,
        isPrimePaymentFlow: true,
        isOnlySubscribe: evt.detail.formType === 'paymentScreen',
      });
    }
  };

  deleteiprCookie = () => {
    const domain = getDomainOnly();
    Cookie.remove('ipr', '/', domain);
  };

  learnMoreHandler = () => {
    const APIURL = this.props.isMobile
      ? timesPrimeLearnMoreAPIURLMOBILE
      : timesPrimeLearnMoreAPIURL;
    let _openUri = `${APIURL}+&redirectUri=${encodeURIComponent(
      document.location.href,
    )}`;
    _openUri = `${_openUri}&ft=0`;
    this.generateTempTicket(res => {
      if (res) {
        _openUri = `${_openUri}&ticketId=${res}`;
      }
      window.open(_openUri, '_blank');
    });
  };

  getUtmQueryString = evt => {
    let queryString = '';
    if (evt && evt.detail && evt.detail.utmsFinal) {
      queryString = Object.keys(evt.detail.utmsFinal)
        .map(key => `${key}=${evt.detail.utmsFinal[key]}`)
        .join('&');
    }
    return queryString;
  };
  generateTempTicket = cb => {
    const _uid = Cookie.get('TicketId');
    const path = `/gettickettp.cms?ticketId=${_uid}`;
    makeRequest
      .get(path, { isMobile: this.props.isMobile })
      .then(data => {
        if (data && data.status === 200 && data.data) {
          cb(data.data);
        } else {
          cb(false);
        }
      })
      .catch(() => {
        cb(false);
      });
  };
  subscribeNow = evt => {
    this.setState({ showPaymentFlow: false });
    if (document) {
      document.body.classList.remove('disable-scroll');
    }
    const event = evt || this.event;
    const queryString = this.getUtmQueryString(event);
    const _prc = getPrcCookieValue('prc');

    const redirect =
      event.detail &&
      event.detail.stop_redirection_for_subscribed &&
      _prc === PRC_FOR_SUBSCRIBED;

    if (!redirect) {
      this.generateTempTicket(res => {
        let _redirectUri = `${timesPrimeSubscribeNowAPIURL}&ft=0&redirectUri=${encodeURIComponent(
          document.location.href,
        )}&${queryString}`;
        if (res) {
          _redirectUri = `${_redirectUri}&ticketId=${res}`;
        }
        window.location.href = _redirectUri;
      });
    }

    // it should not be fire here - Anil
    // this.fireGASubscription(queryString);
  };
  fireGASubscription = utms => {
    const utmMedium = utms.match(/(?:\s)?utm_medium=(\w+);?/);
    const data = {};
    const _prc = getPrcCookieValue('prc');
    data.gaLabel = `success-${_prc}`;
    if (utmMedium && Array.isArray(utmMedium) && utmMedium[1]) {
      data.gaAction = `${utmMedium[1]}|Conversion`;
      sendGaThroughProps({ data });
    }
  };

  closePaymentFlowPopUpCallback = () => {
    if (typeof this.requestedCallback !== 'undefined') {
      delete this.requestedCallback;
    }
    this.setState({ showPaymentFlow: false });
  };

  // primePaymentFlowDoneCallback = response => {
  //   if (typeof this.requestedCallback !== 'undefined') {
  //     //this.requestedCallback(response);
  //   }
  //   if (response.screen === 'expiredScreen' && this.state.isMobile) {
  //     this.closePaymentFlowPopUpCallback();
  //   } else if (
  //     (response.screen === 'successScreen' ||
  //       response.screen === 'failureScreen') &&
  //     this.state.isMobile
  //   ) {
  //     this.setState({ activePaymentFlow: true, iscongratsScreen: true });
  //   } else {
  //     this.setState({ activePaymentFlow: true });
  //   }
  // };

  render() {
    return (
      <>
        {this.state.isPrimePaymentFlowLoaded && (
          <PrimePaymentFlowLoader
            formType={this.state.formType}
            showPaymentFlow={this.state.showPaymentFlow}
            iscongratsScreen={this.state.iscongratsScreen}
            primePaymentFlowDoneCallback={this.primePaymentFlowDoneCallback}
            closePaymentFlowPopUpCallback={this.closePaymentFlowPopUpCallback}
            isMobile={this.props.isMobile}
            primeEvt={this.primeEvt}
            subribeNowFlow={this.subribeNowFlow ? this.subscribeNow : undefined}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  isPrivateUser: state.gdpr.isPrivateUser,
  userData: state.login.userData,
  isMobile: state.isMobile,
});

PrimePaymentFlowCaller.propTypes = {
  userData: PropTypes.shape({ isLoggedIn: PropTypes.bool }),
  isMobile: PropTypes.bool,
};

PrimePaymentFlowCaller.defaultProps = {
  userData: {},
  isMobile: false,
};

export default connect(mapStateToProps)(PrimePaymentFlowCaller);
